/**
 * Format numbers for German locale (e.g. 1234 → "1.234").
 * Use for statistics counts and other integer displays.
 */
export function formatCountDe(n: number): string {
  return n.toLocaleString("de-DE", { maximumFractionDigits: 0 });
}
